import React from 'react';

import { useBrand } from '../../_libs/hooks/useBrand';
import { RiskLabelEnum } from './types';

export interface DataBlurbType {
  value: number | string;
  label: string;
  risk?: LabelEnum | string;
}

const DataBlurb = ({
  value,
  label,
  risk,
}: DataBlurbType) => {
  const { getColors } = useBrand();
  const colors = getColors();
  return (
    <div
      style={{
        color: colors.dark,
      }}
    >
      <div className="f-small f-mono">{label}</div>
      <div className="f-xl f-sans f-bold">{value}</div>
      { 
        (risk == null || risk < 0)
          ? null
          : <div className="f-small f-mono">
              <span className="label">
                { (typeof(risk) === 'string') ? risk : RiskLabelEnum[risk] }
              </span>
            </div>
      }
    </div>
  );
};

export default DataBlurb;
